import { useGalaxyTheme } from "@galaxy-io/dls/theme/useGalaxyTheme";
import { useLayoutEffect } from "react";

/** Retain GTM's stylesheet selector; all colors resolve through DLS CSS tokens. */
export function ThemeBridge() {
  const { activeTheme } = useGalaxyTheme();
  useLayoutEffect(() => {
    document.documentElement.dataset.theme = activeTheme.toLowerCase();
  }, [activeTheme]);
  return null;
}
